export default __webpack_public_path__ + "static/media/production-img-3.8feca040.png";